export enum ActivityPageVariant {
    READ,
    CREATE,
    CLONE,
    READ_CHANGE_REQUEST,
    CREATE_TEMPLATE,
    CLONE_FROM_TEMPLATE,
}
